import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger mb-4"
}
const _hoisted_5 = { class: "item-row" }
const _hoisted_6 = { class: "item-info" }
const _hoisted_7 = { class: "item-row" }
const _hoisted_8 = { class: "item-info" }
const _hoisted_9 = { class: "item-row" }
const _hoisted_10 = { class: "item-info" }
const _hoisted_11 = { class: "item-row" }
const _hoisted_12 = { class: "item-info" }
const _hoisted_13 = { class: "item-row" }
const _hoisted_14 = { class: "item-info" }
const _hoisted_15 = { class: "item-row" }
const _hoisted_16 = { class: "item-info" }
const _hoisted_17 = { class: "item-row" }
const _hoisted_18 = { class: "item-info" }

import { computed, reactive, ref } from 'vue'

interface DataRow {
  data: Record<string, any>
  errors?: Record<string, string[]>
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingGroupeItemDetailsModal',
  setup(__props, { expose: __expose }) {

const isOpened = ref(false)
const itemInfos = reactive({
  nom: '',
  prenom: '',
  date_naissance: '',
  telephone: '',
  email: '',
  salaire: '',
  quotite_cessible_montant: '',
  quotite_cessible_pourcentage: ''
})
const itemErrors = ref<Record<string, string[]>>({})

function open(dataRow: DataRow) {
  Object.assign(itemInfos, dataRow.data || {})
  itemErrors.value = dataRow.errors || {}
  isOpened.value = true
}

function close() {
  isOpened.value = false
}

const errorsText = computed(() => {
  const values = Object.values(itemErrors.value || {})
  if (values.length === 0) {
    return ''
  }
  return values.flat().join(' ')
})

__expose({
  open,
  close
})

return (_ctx: any,_cache: any) => {
  return (isOpened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("header", { class: "modal-header" }, [
            _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "font-semibold mb-0" }, "Informations compte", -1)),
            _createElementVNode("button", {
              class: "btn sm white2",
              onClick: close
            }, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: "/public/icons/icon-close.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_3, [
            (errorsText.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errorsText.value), 1))
              : _createCommentVNode("", true),
            _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-info-perso.svg",
                class: "size-base",
                alt: ""
              }),
              _createTextVNode(" Informations personnelles ")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "label" }, "Nom", -1)),
              _createElementVNode("div", _hoisted_6, _toDisplayString(itemInfos.nom || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "label" }, "Prénoms", -1)),
              _createElementVNode("div", _hoisted_8, _toDisplayString(itemInfos.prenom || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "label" }, "Date naissance", -1)),
              _createElementVNode("div", _hoisted_10, _toDisplayString(itemInfos.date_naissance || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "label" }, "Téléphone", -1)),
              _createElementVNode("div", _hoisted_12, _toDisplayString(itemInfos.telephone || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "label" }, "Adresse Email", -1)),
              _createElementVNode("div", _hoisted_14, _toDisplayString(itemInfos.email || '-'), 1)
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("h5", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-engagement.svg",
                class: "size-base",
                alt: ""
              }),
              _createTextVNode(" Engagement ")
            ], -1)),
            _createElementVNode("div", _hoisted_15, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label" }, "Salaire brut", -1)),
              _createElementVNode("div", _hoisted_16, _toDisplayString(itemInfos.salaire || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label" }, "Quotité cessible", -1)),
              _createElementVNode("div", _hoisted_18, _toDisplayString(itemInfos.quotite_cessible_montant) + " (" + _toDisplayString(itemInfos.quotite_cessible_pourcentage) + "%) ", 1)
            ])
          ]),
          _createElementVNode("footer", { class: "modal-footer" }, [
            _createElementVNode("button", {
              class: "btn-ultra white2",
              style: {"justify-content":"center"},
              onClick: close
            }, "Fermer")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})